export type Priority = 'urgence' | 'action' | 'service' | 'activite' | 'statut' | 'suggestion'

export interface ForYouItem {
  id: string
  priority: Priority
  eyebrow: string
  title: string
  detail: string
  cta: string
  to: string
}

export interface EspaceService {
  id: string
  name: string
  context: string
  icon: 'card' | 'trash' | 'ball' | 'request' | 'booking' | 'invoice' | 'bell' | 'pet'
  to: string
}

export const citizenFirstName = 'Charlotte'

export const forYouItems: ForYouItem[] = [
  {
    id: 'ebullition',
    priority: 'urgence',
    eyebrow: 'Avis d’ébullition',
    title: 'Votre adresse du 4590, rue Bourgogne est concernée.',
    detail: 'En vigueur depuis aujourd’hui, 14 h 30.',
    cta: 'Voir les consignes',
    to: '/notifications',
  },
  {
    id: 'collecte',
    priority: 'service',
    eyebrow: 'Collectes',
    title: 'Collecte demain',
    detail: 'Recyclage · Matières organiques · à sortir ce soir',
    cta: 'Voir mes collectes',
    to: '/mes-collectes',
  },
  {
    id: 'natation',
    priority: 'activite',
    eyebrow: 'Loisirs',
    title: 'Natation d’Emma',
    detail: 'Samedi · 10 h · Complexe aquatique de Brossard',
    cta: 'Voir l’activité',
    to: '/mes-loisirs',
  },
  {
    id: 'demande',
    priority: 'statut',
    eyebrow: 'Demande #REQ-2841',
    title: 'Nid-de-poule — nouveau statut : En traitement',
    detail: '4590, rue Bourgogne · mis à jour le 28 août',
    cta: 'Suivre ma demande',
    to: '/mes-demandes/req-2841',
  },
  {
    id: 'milo',
    priority: 'action',
    eyebrow: 'Mon animal',
    title: 'Rappel de vaccin pour Milo',
    detail: 'Prévu le 14 octobre · information partagée par Vet&Cie',
    cta: 'Voir Milo',
    to: '/mes-animaux/milo',
  },
  {
    id: 'pickleball',
    priority: 'action',
    eyebrow: 'Inscription',
    title: 'Pickleball',
    detail: 'Les inscriptions ouvrent lundi à 9 h.',
    cta: 'Me prévenir',
    to: '/mes-loisirs',
  },
]

export const espaceServices: EspaceService[] = [
  {
    id: 'carte',
    name: 'Carte numérique',
    context: 'Active · accès au Complexe aquatique et aux loisirs',
    icon: 'card',
    to: '/ma-carte',
  },
  { id: 'collectes', name: 'Collectes', context: 'Prochaine collecte demain', icon: 'trash', to: '/mes-collectes' },
  { id: 'loisirs', name: 'Loisirs', context: '2 activités familiales cette semaine', icon: 'ball', to: '/mes-loisirs' },
  { id: 'demandes', name: 'Mes demandes', context: '1 demande en traitement', icon: 'request', to: '/mes-demandes' },
  { id: 'reservations', name: 'Réservations', context: 'Salles et plateaux sportifs', icon: 'booking', to: '/mes-loisirs' },
  { id: 'factures', name: 'Factures', context: '1 facture à payer', icon: 'invoice', to: '/mon-profil' },
  { id: 'avis', name: 'Notifications', context: '3 avis non lus', icon: 'bell', to: '/notifications' },
  { id: 'animaux', name: 'Mes animaux', context: 'Milo · médaille active', icon: 'pet', to: '/mes-animaux' },
]

export const discoverItems = [
  {
    id: 'equipement',
    title: 'Découvrez la réservation de salles et de plateaux sportifs',
    detail: 'Gymnases, salles communautaires et plateaux, réservés en ligne.',
    to: '/mes-loisirs',
  },
  {
    id: 'rappels',
    title: 'Recevez les rappels de collecte',
    detail: 'Un avis la veille, sur le canal de votre choix.',
    to: '/notifications/parametres',
  },
]

export interface EspaceNavItem {
  id: string
  label: string
  icon: 'home' | 'card' | 'profile' | 'bell' | 'trash' | 'request'
  to: string
}

export const espaceNav: EspaceNavItem[] = [
  { id: 'accueil', label: 'Accueil', icon: 'home', to: '/mon-espace' },
  { id: 'carte', label: 'Ma carte', icon: 'card', to: '/ma-carte' },
  { id: 'profil', label: 'Mon profil', icon: 'profile', to: '/mon-profil' },
  { id: 'avis', label: 'Notifications', icon: 'bell', to: '/notifications' },
  { id: 'collectes', label: 'Mes collectes', icon: 'trash', to: '/mes-collectes' },
  { id: 'requete', label: 'Requête', icon: 'request', to: '/mes-demandes' },
]

export interface LocalNewsItem {
  id: string
  date: string
  category: string
  title: string
  image: string
  to?: string
}

export const localNews: LocalNewsItem[] = [
  {
    id: 'retard',
    date: '28 août 2026',
    category: 'Collecte',
    title: 'Retard de la collecte des matières organiques dans le secteur B',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5fd42455-d112-4234-8bf8-10181a8b6838.jpg',
    to: '/mes-collectes',
  },
  {
    id: 'uci',
    date: '28 août 2026',
    category: 'Événement',
    title: 'Les Mondiaux de cyclisme traversent Brossard',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7ad27924-d7a2-4c4d-9a2c-3e0d9728c42e.jpg',
  },
  {
    id: 'promulgation',
    date: '27 août 2026',
    category: 'Avis public',
    title: 'Avis public de promulgation — règlement 2026-14',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5c1bb1a0-98ab-4fff-a0e3-94c11eaefb42.jpg',
  },
]

export interface NearbyEvent {
  id: string
  date: string
  time?: string
  title: string
  image: string
}

export const nearbyEvents: NearbyEvent[] = [
  {
    id: 'jour-de-larbre',
    date: 'Jusqu’au 15 sept.',
    time: 'Boul. Matte',
    title: 'Jour de l’arbre et distribution de compost',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/66b2a568-92b6-454c-9209-0204adb6a2b4.jpg',
  },
  {
    id: 'uci-route',
    date: 'Du 20 au 27 sept.',
    title: 'Championnats du Monde Route UCI 2026',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7ad27924-d7a2-4c4d-9a2c-3e0d9728c42e.jpg',
  },
  {
    id: 'pompiers',
    date: 'Sam. 26 sept.',
    time: 'Dès 10 h',
    title: 'Au feu, les pompiers!',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7c3efef4-2477-4098-a5eb-04cd1fab915d.jpg',
  },
]

export interface UsefulService {
  id: string
  name: string
  open: boolean
  hours: string
  image: string
}

export const usefulServices: UsefulService[] = [
  {
    id: 'ville',
    name: 'Hôtel de ville de Brossard',
    open: false,
    hours: 'Ouvre lundi 8 h 30',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d961d921-fc64-4172-a775-2646a67bcd2f.jpg',
  },
  {
    id: 'biblio',
    name: 'Bibliothèque de Brossard',
    open: true,
    hours: 'Ferme à 20 h',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/66b2a568-92b6-454c-9209-0204adb6a2b4.jpg',
  },
  {
    id: 'aquatique',
    name: 'Complexe aquatique de Brossard',
    open: true,
    hours: 'Ferme à 21 h',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5c1bb1a0-98ab-4fff-a0e3-94c11eaefb42.jpg',
  },
  {
    id: 'ecocentre',
    name: 'Écocentre — boul. Matte',
    open: false,
    hours: 'Ouvre samedi 9 h',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c135d2b5-e60f-4b53-a073-49b4840fbe05.jpg',
  },
  {
    id: 'multigenerationnel',
    name: 'Centre multigénérationnel de Brossard',
    open: false,
    hours: 'Ouvre lundi 8 h',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/0bf26428-32e7-41de-8bd9-514123997710.jpg',
  },
]

export const appBenefits = [
  { id: 'carte', label: 'Votre carte toujours avec vous', icon: 'card' },
  { id: 'alertes', label: 'Recevez ce qui vous concerne', icon: 'bell' },
  { id: 'lieu', label: 'Des services adaptés à l’endroit où vous êtes', icon: 'pin' },
  { id: 'photo', label: 'Signalez un problème en quelques secondes', icon: 'camera' },
  { id: 'acces', label: 'Accédez à vos activités et installations', icon: 'key' },
] as const

export const mobileItems = [
  { id: 'collecte', eyebrow: 'Collecte demain', detail: 'Recyclage' },
  { id: 'natation', eyebrow: 'Natation d’Emma', detail: 'Samedi · 10 h' },
  { id: 'demande', eyebrow: 'Demande #2841', detail: 'En traitement' },
]
